<template>
  <div>
    <v-app class="p-4">
      <div class="col-md-12 p-0 mt-5 pt-5 mx-auto" style="border: none!important;">
        <v-dialog
            transition="dialog-bottom-transition"
            max-width="600"
            v-model="moreInformation"
        >
          <template>
            <v-card>
              <v-toolbar
                  flat
                  dark
                  color="primary"
              >
                <v-toolbar-title>اطلاعات بیشتر</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-btn
                      icon
                      dark
                      @click="moreInformation = false"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text>
                <div class="pa-12">
                  <div class="py-2 border-bottom my-2">
                    <p class="d-block text-dark" style="font-size: 10pt">عنوان آگهی : </p>
                    <p class="mr-3" style="font-size: 9pt"> {{ adsInformation['title'] }} </p>
                  </div>
                  <div class="py-2 border-bottom my-2">
                    <p class="d-block text-dark" style="font-size: 10pt">توضیحات آگهی : </p>
                    <p class="mr-3" style="font-size: 9pt"> {{ adsInformation['description'] }} </p>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </template>
        </v-dialog>
        <div class="mt-5 pt-5">

          <v-card :loading="loading" class="p-3 pt-0">
            <data-table
                :data="data"
                :columns="columns"
                :debounce-delay="3000"
                :translate="translate"
                :per-page="[10, 25, 50, 100, 500]"
                :pagination="paginate"
                @on-table-props-changed="reloadTable"
                :orderBy="tableProps.column"
                :orderDir="tableProps.dir"
                :loading="true"
                class="pt-5 table-striped text-center table-hover table-responsive-lg table-responsive-md table-responsive-sm table-responsive-xs"
            >
              <template slot="filters" slot-scope="{ tableFilters, perPage }">
                <filters-table @getInfo="(val)=>{ if (val) tableProps.search = searchBox.search;reloadTable() }"
                               v-model="searchBox"></filters-table>
              </template>
            </data-table>
          </v-card>
        </div>
      </div>
    </v-app>
  </div>
</template>

<script>
import {dataTableProps} from "@/main";
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import Swal from "sweetalert2";
import {debounce} from "../../../custom";
import button from "@/view/pages/button";
import FiltersTable from "@/components/Table/filtersTable";

export default {
  name: "AdsMonitoring",
  components: {FiltersTable, TitleRibbon},
  data() {
    return {
      dialog: false,
      loading: false,
      translate: dataTableProps.translate,
      tableProps: dataTableProps.tableProps,
      paginate: dataTableProps.pagination,
      groupModal: false,
      moreInformation: false,
      chargeMount: '',
      adsInformation: [],
      numbersInfo: false,
      selectedNumber: [],
      dataId: '',
      columns: [
        {
          label: '<input type="checkbox" id="selectAll">',
          transform: (val) => {
            return `<input type="checkbox"  data-id="${val.data.phone}">`
          },
          orderable: false,
        },
        {
          label: 'ردیف',
          transform: (val) => {
            let row = this.data.current_page - 1;
            row = row * this.data.per_page;
            return row + val.row + 1;
          },
          orderable: true,
        },
        {
          label: 'شناسه',
          name: 'id',
          orderable: true,
          searchable: true,
        },
        {
          label: 'کاربر',
          name: 'nickname',
          transform(val) {
            return val.data.user.name + ' ' + val.data.user.lastName
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'موضوع',
          name: 'title',
          orderable: true,
          searchable: true,
        },
        {
          label: 'شماره',
          name: 'phone',
          orderable: true,
          searchable: true,
        },
        {
          label: 'زمان ارسال',
          name: 'available_at_p',
          orderable: true,
          searchable: true,
        },
        {
          label: 'مدیریت',
          name: 'action',
          component: button,
          handler: this.actions,
          event: "action",
          meta: {
            permission_prefix: 'notification_',
            buttons: [
              {
                name: 'moreInfo',
                label: 'اطلاعات بیشتر',
                icon: 'info-circle',
                class: 'btn-outline-primary',
                action: this.actions,
                status: 'divar_update',
              },
              {
                name: 'deleteAds',
                label: 'حذف آگهی',
                icon: 'trash-alt',
                class: 'btn-outline-danger',
                action: this.actions,
                status: 'divar_update',
              },

            ]
          }
        }

      ],
      data: {},
      url: `${url}/admin/monitoring/future`,
      searchBox: {
        search: '',
        length: 10
      },
    }
  },
  watch: {
    searchBox: {
      handler() {
        this.tableProps.length = this.searchBox.length;
        this.reloadTable();
      },
      deep: true
    }
  },
  methods: {
    getDataForTable(url = this.url, query = this.tableProps) {
      const vm = this;
      vm.loading = true;
      $.ajax({
        url: url,
        type: 'GET',
        fn: this.getDataForTable,
        data: query,
        headers: {
          "ACCEPT": "application/json",
          "Authorization": Token
        },
        success: function (data) {
          vm.data = data.data;
          vm.loading = false;
        }
      })
    },
    reloadTable(tableProps) {
      debounce(() => {
        this.tableProps.page = this.data.current_page;
        this.getDataForTable(this.url, tableProps);
      }, 1000);
    },
    showMoreInfo(values) {
      this.moreInformation = true
      this.adsInformation = values
    },
    actions(data, type) {
      if (type === 'deleteAds') {
        const del = Swal.fire({
          title: 'از حذف این آگهی اطمینان دارید؟',
          showCancelButton: true,
          cancelButtonText: 'خیر',
          confirmButtonText: 'بله',
          icon: 'question',
          buttons: true
        }).then((val) => {
          if (!val.isDismissed)
            $.ajax({
              url: `${url}/admin/monitoring/future/${data.id}`,
              type: 'DELETE',
              fn: del,
              params: [data.id],
              headers: {
                ACCEPT: "application/json",
                Authorization: Token
              },
              msg: true,
              success: (res) => {
                this.reloadTable();
              }
            })

        })
      } else if (type === 'moreInfo') {
        this.moreInformation = true
        this.adsInformation['title'] = data.title;
        this.adsInformation['description'] = data.description;
      }
    },
    deleteData: (id) => {


    }
  },
  mounted() {
    this.tableProps = {
      search: '',
      length: 10,
      column: 'id',
      dir: 'desc',
      page: 1,
    };
    this.getDataForTable(this.url)

    $(document).on('click', '#selectAll', (element) => {
      if ($(element.target).is(':checked')) {
        $('input[type="checkbox"]').prop('checked', true);

        const selected = $('input[type="checkbox"]').map(function () {
          return $(this).data('id')
        }).get();

        this.selectedNumber = selected;
      } else {
        $('input[type="checkbox"]').prop('checked', false)
        this.selectedNumber = []
      }
    })
  },
}
</script>

<style scoped>

</style>